import GoalTemplatesTable from "@components/GoalTemplatesTable";
import ExpertJourneyTablesPage from "@components/pageTypes/ExpertJourneyTablesPage";

type Props = {
  journeyId: string;
};

const ExpertJourneyGoalTemplatesTablePage = ({ journeyId }: Props) => (
  <ExpertJourneyTablesPage
    helmetKey="pageTitles.expertJourney.goalTemplate.list"
    imageName="womanWithCoffee"
    journeyId={journeyId}
    titleKey="pages.expertJourney.goalTemplates.title"
  >
    <GoalTemplatesTable journeyId={journeyId} />
  </ExpertJourneyTablesPage>
);

export default ExpertJourneyGoalTemplatesTablePage;
